import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import BottomNav from './components/BottomNav';
import Home from './pages/Home';
import Tours from './pages/Tours';
import Fleet from './pages/Fleet';
import Gallery from './pages/Gallery';
import About from './pages/About';
import Contact from './pages/Contact';
import MapPlaces from './pages/MapPlaces';
import NotFound from './pages/NotFound';
import DriverTrip from './pages/DriverTrip';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
}

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/"        element={<Home />} />
          <Route path="/tours"   element={<Tours />} />
          <Route path="/fleet"   element={<Fleet />} />
          <Route path="/map"     element={<MapPlaces />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/about"   element={<About />} />
          <Route path="/contact" element={<Contact />} /> 
         
          {/* Driver Panel */}
          <Route path="/driver" element={<DriverTrip />} />

          <Route path="*"        element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppFloat />
      <BottomNav />
    </Router>
  );
}
